import {addNotification as notify} from 'reapop'
import {httpStatus} from '../constants/variableConstant'

export function sendData(type, response) {
  return {
    type,
    response
  }
}

export function notifyErrorNetwork() {
  return dispatch => {
    dispatch(notify({
       title: 'Thông báo',
       message: 'Lỗi kết nối',
       status: 'error',
       position: 'br',
       dismissible: true,
       dismissAfter: 5000
     }))
  }
}

export function notifyResponse(status, message) {
  return dispatch => {
    notify({
       title: 'Thông báo',
       message: message,
       status: status,
       position: 'br',
       dismissible: true,
       dismissAfter: 5000
     })
  }
}

export function notifySuccess(response, messageSuccess) {
  return dispatch => {
    let status = null, message = null
    if (response.responseStatus === httpStatus.success) {
      status = 'success'
      message = messageSuccess
    } else {
      status = 'error'
      message = response.responseMessage
    }
    dispatch(notify({
       title: 'Thông báo',
       message: message,
       status: status,
       position: 'br',
       dismissible: true,
       dismissAfter: 5000
     }))
  }
}
